import {Pipe, PipeTransform} from '@angular/core';

import moment from 'moment';
import 'moment/locale/es';

@Pipe({
  name: 'tareasPipe',
})
export class TareasPipe implements PipeTransform {


  transform(items: any[], filter: any) {
    let aux = [];

    let now = moment();
    let limitNextDay = moment().hour(filter['ver_tareas_de_ayer_hora']);

    let now0 = new Date();
    let now1 = new Date();

    now0.setHours(0);
    now0.setMinutes(0);
    now0.setSeconds(0);
    now0.setMilliseconds(0);

    now1.setDate(now1.getDate() + 1);
    now1.setHours(0);
    now1.setMinutes(0);
    now1.setSeconds(0);
    now1.setMilliseconds(0);


    if (items) {

      if (parseFloat(filter.periodo)) {
        items = items.filter((item) => item.id_periodo == parseFloat(filter.periodo));
      }

      for (let item of items) {

        //item.extratime = false;
        let entraEncursoExtra = false;

        if (filter['ver_tareas_de_ayer'] == 1) {


          let itemPlusTime = moment(parseInt(item.fecha)).add(1, 'days');
          if (now.isBefore(limitNextDay) && itemPlusTime.isSame(now, 'days')) {

            entraEncursoExtra = true;
            item.extratime = true;
          }
        }

        //pendientes
        if (filter['menu'] == 1 && item.fecha < now0.getTime() && !item.persistente && !entraEncursoExtra) {

          aux.push(item);


          //proximas
        } else if (filter['menu'] == 2 && item.fecha > now1.getTime()) {

          aux.push(item);


          //en curso
        } else if (filter['menu'] == 0 && ((item.fecha >= now0.getTime() && item.fecha <= now1.getTime()) || item.persistente || entraEncursoExtra)) {

          aux.push(item);
        }
      }
    }

    return aux;
  }
}



// WEBPACK FOOTER //
// ./src/pipes/tareas/tareas.ts